/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "../../css/products.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  IconButton,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import {
  faPen,
  faTrash,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../Environment";
import { RotatingLines } from "react-loader-spinner";
export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [categories, setCategories] = useState([]);
  const [loadedData, setLoadedData] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedTag, setSelectedTag] = useState("All Categories");
  const handleProductClick = (product) => {
    const productTitleSlug = product.title.replace(/\s+/g, "-").toLowerCase();
    navigate(`/productsDetails/${productTitleSlug}`, { state: { product } });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(baseUrl + "productdetails/allproducts");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setLoadedData(data[0]?.products || []);
        setLoading(false);
        if (selectedTag === "All Categories") {
          setProducts(data[0]?.products || []);
        }
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const handleChangeTag = (event) => {
    const selectedCategory = event.target.value;
    setSelectedTag(selectedCategory);
    if (selectedCategory === "All Categories") {
      setProducts(loadedData);
    } else {
      setProducts(
        loadedData.filter((item) => item.category === selectedCategory),
      );
    }
  };
  const handleClearFilter = () => {
    setSelectedTag("All Categories");
    setProducts(loadedData);
  };
  useEffect(() => {
    if (products.length > 0) {
      extractCategories(loadedData);
    }
  }, [loadedData]);
  useEffect(() => {
    extractSubCategories(products);
  }, [products]);
  const handleToggleHide = async (product) => {
    try {
      const response = await fetch(
        baseUrl + `productdetails/toggle-hide/${product._id}`,
        { method: "PATCH" },
      );
      if (!response.ok) {
        throw new Error("Failed to update product visibility");
      }
      const data = await response.json();

      // keep both the filtered list and the master list in sync
      setProducts((prev) =>
        prev.map((p) =>
          p._id === product._id ? { ...p, isHidden: data.isHidden } : p,
        ),
      );
      setLoadedData((prev) =>
        prev.map((p) =>
          p._id === product._id ? { ...p, isHidden: data.isHidden } : p,
        ),
      );

      toast.success(data.message, { style: { color: "white" } });
    } catch (error) {
      console.error("Error toggling visibility:", error);
      toast.error(
        `Failed to update visibility for "${product.title}". Please try again.`,
        { style: { color: "white" } },
      );
    }
  };
  const extractCategories = (data) => {
    const uniqueCategories = [...new Set(data.map((item) => item.category))];

    setCategories(uniqueCategories);
  };
  const extractSubCategories = (data) => {
    const uniqueSubCategories = [
      ...new Set(products.map((item) => item.subcategory)),
    ];
    setSubCategories(uniqueSubCategories);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };
  const currentProducts = products.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  if (loading) {
    return (
      <div
        className="relative h-[100vh] flex items-center justify-center"
        style={{ position: "relative", height: "100vh" }}
      >
        <div
          className=" flex items-center justify-center"
          style={{
            position: "absolute",
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RotatingLines
            visible={true}
            height="150"
            width="150"
            color="red"
            strokeColor="#24425a"
            strokeWidth="5"
            animationDuration="0.75"
            ariaLabel="rotating-lines-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </div>
    );
  }
  if (error) {
    return <div>Error: {error}</div>;
  }
  if (products.length === 0) {
    return <div>No products found</div>;
  }
  const handleEditProduct = (product) => {
    navigate("/Add-Product", { state: { product } });
  };
  const handleOpenDialog = (product) => {
    setSelectedProduct(product);

    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedProduct(null);
  };
  const handleDeleteProduct = async () => {
    if (!selectedProduct) return;
    try {
      setLoading(true);
      const response = await fetch(
        baseUrl + `productdetails/${selectedProduct._id}`,
        {
          method: "DELETE",
        },
      );
      if (!response.ok) {
        throw new Error("Failed to delete product");
      }
      setProducts(
        products.filter((product) => product._id !== selectedProduct._id),
      );
      toast.success(`"${selectedProduct.title}" deleted successfully!`, {
        style: {
          color: "white",
        },
      });
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error(
        `Failed to delete product "${selectedProduct.title}". Please try again.`,
        {
          style: {
            color: "white",
          },
        },
      );
    } finally {
      setLoading(false);
      handleCloseDialog();
    }
  };
  return (
    <div className="all-products">
      <Container fluid>
        <div className="products-page-heading d-flex">
          <div className="flex justify-start items-center gap-3 flex-wrap">
            {" "}
            <h1>Products</h1>
            <Box display="flex" alignItems="center">
              <FormControl sx={{ width: 180 }} size="small">
                <InputLabel id="single-checkbox-select-label">
                  Filter Categories
                </InputLabel>
                <Select
                  labelId="single-checkbox-select-label"
                  id="single-checkbox-select"
                  value={selectedTag}
                  onChange={handleChangeTag}
                  input={<OutlinedInput label="Filter Categories" />}
                  renderValue={(selected) => selected}
                >
                  {categories.map((name) => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={selectedTag === name} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {selectedTag === "All Categories" ? (
              ""
            ) : (
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={handleClearFilter}
              >
                Clear Filter
              </Button>
            )}
          </div>
          <Button className="ms-auto" variant="contained">
            <Link to="/Add-Product">Add product</Link>
          </Button>
        </div>
        <div
          className="all-product-list mb-5"
          style={{ height: "70vh", overflowY: "scroll", overflowX: "auto" }}
        >
          {products.length > 0 ? (
            <Table>
              <TableHead className="thead-box z-[999]">
                <TableRow style={{ borderBottom: "2px solid gray" }}>
                  <TableCell
                    className="col w-6"
                    style={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      padding: "0 !important",
                    }}
                  >
                    #
                  </TableCell>
                  <TableCell
                    className="col"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Product
                  </TableCell>
                  <TableCell
                    className="col"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Category
                  </TableCell>
                  <TableCell
                    className="col"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    Subcategory
                  </TableCell>
                  <TableCell
                    className="col"
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                  >
                    SKU
                  </TableCell>
                  <TableCell
                    className="col"
                    style={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      zIndex: "999",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentProducts.map((product, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      borderBottom: "1.5px solid gray",
                      backgroundColor: index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                    }}
                  >
                    <TableCell
                      className="w-6"
                      style={{ padding: "0 !important" }}
                    >
                      {index + 1 + page * rowsPerPage}.
                    </TableCell>
                    <TableCell className="w-28">
                      <div
                        className="d-flex gap-5 align-items-center title"
                        onClick={() => handleProductClick(product)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="product-image">
                          <img src={product.imageurl[0]} alt={product.title} />
                        </div>
                        {product.title}
                      </div>
                    </TableCell>
                    <TableCell className="w-28 ">{product.category}</TableCell>
                    <TableCell className="w-20">
                      {product.subcategory}
                    </TableCell>
                    <TableCell className="w-28">{product._id}</TableCell>
                    <TableCell className="w-28 actions z-[-999]">
                      <IconButton
                        size="small"
                        onClick={() => handleToggleHide(product)}
                        title={
                          product.isHidden ? "Unhide product" : "Hide product"
                        }
                      >
                        <FontAwesomeIcon
                          icon={product.isHidden ? faEyeSlash : faEye}
                          className="text-[#555]"
                        />
                      </IconButton>{" "}
                      <IconButton
                        size="small"
                        onClick={() => handleEditProduct(product)}
                      >
                        <FontAwesomeIcon
                          icon={faPen}
                          className="text-[green]"
                        />
                      </IconButton>{" "}
                      <IconButton
                        size="small"
                        onClick={() => handleOpenDialog(product)}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="text-[red]"
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    count={products.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          ) : (
            <div className="p-3">No products found..</div>
          )}
        </div>
      </Container>
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the product "
            <strong>{selectedProduct?.title}</strong>"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleDeleteProduct}
            color="error"
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
